<template>
  <div v-if="configData.Text">
    <p
      :class="{
        'heading-xxs': configData.FontWeight?.toLowerCase() === 'bold',
      }"
      class="max-w-600"
      v-html="textContent"
    ></p>
  </div>
</template>

<script lang="ts" setup>
import { markup_markdownLikeTextToHtmlString } from '~/utils/markup/allTextTransformations';

interface Props {
  configData: {
    Text: string;
    FontWeight?: string;
  };
}

const props = defineProps<Props>();
let textContent = props.configData?.Text;

if (textContent) {
  textContent = markup_markdownLikeTextToHtmlString(textContent);
  textContent = markup_convertMarkdownIntoFamilyPriceHtml(textContent);
}
</script>

<style scoped></style>
